// @ts-check

import {
  getOrgConfigForTenant as getOrgConfigForTenantQuery,
  updateOrgConfigForTenant as updateOrgConfigForTenantMutation,
} from "src/queries/orgConfig.graphql";

import { useOrgConfig } from "./useOrgConfig";

/**
 * Hook for managing org config for tenant.
 * @returns {{
 *  loading: boolean,
 *  config: org_config.tenant.Config,
 *  createdBy: string,
 *  createdAt: import("moment").Moment,
 *  update: (config: org_config.tenant.Config) => Promise<boolean>,
 *  updating: boolean,
 * }}
 */
export const useOrgConfigForTenant = () =>
  useOrgConfig({
    getQuery: getOrgConfigForTenantQuery,
    updateMutation: updateOrgConfigForTenantMutation,
  });
